export default "__VITE_ASSET__YMx9QlPy__"